import React, { useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import MarketsAssets from './subComponents/MarketsAssets';
import MarketsGraph, { MarketGraphData } from './subComponents/MarketsGraph';
import type { MarketsOverviewPayload } from '../../../api/rs-hg/markets';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: '1.25em 1.25em 0 1.25em',
    width: '100%',
    height: '100%',
    gap: '1.25em',
  },
  bottom: {
    display: 'flex',
    gap: '1.25em',
  },
});

const mapTimeseriesData = (
  payload: MarketsOverviewPayload,
): MarketGraphData[] => {
  return Object.keys(payload.timeseries_graphs).map((key) => {
    const assetData_Graph = payload.timeseries_graphs[key];

    if (
      assetData_Graph.price_timeseries &&
      Array.isArray(assetData_Graph.price_timeseries) &&
      assetData_Graph.return_timeseries &&
      Array.isArray(assetData_Graph.return_timeseries)
    ) {
      const price_numbers = assetData_Graph.price_timeseries.map(
        (item: [number, number]) => item[1],
      );
      const price_times = assetData_Graph.price_timeseries.map(
        (item: [number, number]) => String(item[0]),
      );
      const return_numbers = assetData_Graph.return_timeseries.map(
        (item: [number, number]) => item[1],
      );
      const return_times = assetData_Graph.return_timeseries.map(
        (item: [number, number]) => String(item[0]),
      );

      return {
        asset: key,
        price: price_numbers,
        price_time: price_times,
        return: return_numbers,
        return_time: return_times,
      };
    } else {
      return {
        asset: key,
        price: [],
        price_time: [],
        return: [],
        return_time: [],
      };
    }
  });
};

interface MarketsPageProps {
  data: MarketsOverviewPayload;
}

const MarketsPage: React.FC<MarketsPageProps> = ({ data }) => {
  const classes = useStyles();
  const [displayedGraph, setDisplayedGraph] = useState<string>(
    String(data.data_table[0].asset_name),
  );

  return (
    <div className={classes.container}>
      <MarketsAssets
        marketAssetData={data.data_table}
        columns={data.table_columns}
        setGraph={setDisplayedGraph}
      />
      <MarketsGraph
        graphData={mapTimeseriesData(data)}
        chosenAsset={displayedGraph}
      />
    </div>
  );
};

export default MarketsPage;
